import { User } from './user';

export enum ListType {
  Account = 'Account',
  Prospect = 'Prospect',
  Lead = 'Lead',
  Template = 'Template',
  Strategy = 'Strategy',
  User = 'User',
}
export interface List {
  id: number;
  name: string;
  type: ListType;
  shared: boolean; //means shared with all
  userId: number;
  owner: string;
  owned: boolean;
  sharedUsers: User[] | null;
}
